/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from "vue";
import VueAnalytics from "vue-analytics";
import Router from "vue-router";
import Meta from "vue-meta";
import store from "../store/modules";
import moment from "moment";

// Routes
import paths from "./paths";

const ifNotAuthenticated = (to, from, next) => {
    if (!store.authentication.getters.isAuthenticated) {
        next();
        return;
    }
    next("/");
};

const lessThanOneDayAgo = (date) => {
    const twentyFourHours = 24000 * 60 * 60;
    const twentyFourHoursAgo = Date.now() - twentyFourHours;

    return Date.parse(date) > twentyFourHoursAgo;
};

const isValidToken = (token) => {
    return lessThanOneDayAgo(token);
};

const getClaims = () => {
    if (store.authentication.state) {
        return getAsArray(store.authentication.state.claims);
    }

    return getAsArray(store.authentication.getters.getClaims());
};

function getAsArray(value) {
    if (Array.isArray(value)) return value;

    return value.split(",");
}

const getIsAdmin = (isAdmin) => {
    if (!isAdmin || isAdmin == "false") return false;

    return true;
};

const allowEntry = (page) => {
    let claims = [];
    let isAdmin = false;
    claims = getClaims();

    if (store.authentication.state.user) {
        claims.push("UtaDashboard");
        claims.push("HelpDeskRequests");
        claims.push("HelpDeskRequestView");
        claims.push("SharedFiles");
        claims.push("FilesSharedWithUser");
        claims.push("CustomPayment");
    }

    if (store.authentication.state) {
        isAdmin = getIsAdmin(store.authentication.state.isAdmin);

        return isAdmin || claims.includes(page);
    }

    isAdmin = getIsAdmin(store.authentication.getters.isAdmin());

    return isAdmin || claims.includes(page);
};

const ifAuthenticated = (to, from, next) => {
    // if (
    //     window.location.origin.startsWith("http://localhost:8080") ||
    //     window.location.href.includes("api")
    // ) {
    //     next();

    //     return;
    // }

    if (!allowEntry(to.name) && to.path != "/login" && to.path != "/conference-room-kiosk") {
        next({
            path: "/login",
            query: { redirect: to.fullPath },
        });

        return;
    }

    next();

    return;

    // next({
    //     path: "/login",
    //     query: {
    //         redirect: to.name,
    //         params: to.params
    //     }
    // });
};

function route({ path, view, name, filePath }) {
    const viewPath = filePath ? filePath + "/" + view : view;

    return {
        name: name || view,
        path,
        component: (resovle) => import(`@/views/${viewPath}.vue`).then(resovle),
        beforeEnter: ifAuthenticated,
    };
}

Vue.use(Router);

// const redirect = getIsAdmin(store.authentication.state.isAdmin)
//     ? "/accounts"
//     : paths.find((p) => {
//         return p.name == getClaims()[0];
//     })
//     ? paths.find((p) => p.name == getClaims()[0]).path
//     : "/login";

const redirect = () => {
    //if (getIsAdmin(store.authentication.state.isAdmin)) return "/dashboard";
    return "/dashboard";

    const page = paths.find((p) => {
        return !p.path.includes(":") && getClaims().includes(p.name);
    });

    return page ? page.path : "/login";
};

// Create a new router
const router = new Router({
    mode: "history",
    routes: paths
        .map((path) => route(path))
        .concat([{ path: "*", redirect: redirect() }]),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return { selector: to.hash };
        }
        return { x: 0, y: 0 };
    },
});

Vue.use(Meta);

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
if (process.env.GOOGLE_ANALYTICS) {
    Vue.use(VueAnalytics, {
        id: process.env.GOOGLE_ANALYTICS,
        router,
        autoTracking: {
            page: process.env.NODE_ENV !== "development",
        },
    });
}

export default router;
